import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledCopyright = styled.div`
  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 著作権についてのページ
 */
const Copyright: FC = () => {
  return (
    <StyledCopyright>
      <h2>著作権について</h2>
      <p>
        本ウェブサイトに掲載の記事・写真・図表・映像など、掲載内容の無断転載を禁止します。
        すべての内容は日本の著作権法ならびに国際条約により保護されています。
      </p>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledCopyright>
  );
};

export default Copyright;
